if (!customElements.get('load-more-pagination')) {
  class LoadMorePagination extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-load-more-button]');
      if (!this.button) return;
      this.button.addEventListener('click', this.loadNext.bind(this));
    }

    async loadNext() {
      const nextUrl = this.button.dataset.nextUrl;
      const sectionId = this.button.dataset.sectionId;
      if (!nextUrl || this.loading) return;
      this.loading = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.disabled = true;
      const spinner = this.querySelector('.load-more-pagination__spinner');
      if (spinner) spinner.hidden = false;

      try {
        const separator = nextUrl.includes('?') ? '&' : '?';
        const response = await fetch(`${nextUrl}${separator}section_id=${sectionId}`);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const newGrid = doc.querySelector('[data-product-column]');
        const currentGrid = this.closest('#ProductGridContainer')?.querySelector('[data-product-column]')
          || document.querySelector('[data-product-column]');
        if (newGrid && currentGrid) {
          Array.from(newGrid.children).forEach((child) => currentGrid.appendChild(child));
        }

        const newButton = doc.querySelector('[data-load-more-button]');
        if (newButton && newButton.dataset.nextUrl) {
          this.button.dataset.nextUrl = newButton.dataset.nextUrl;
        } else {
          this.remove();
        }
      } catch (error) {
        // leave the button as-is so the visitor can retry
      } finally {
        this.loading = false;
        if (this.button && this.button.isConnected) {
          this.button.removeAttribute('aria-busy');
          this.button.disabled = false;
          if (spinner) spinner.hidden = true;
        }
      }
    }
  }
  customElements.define('load-more-pagination', LoadMorePagination);
}

if (!customElements.get('infinite-scroll-pagination')) {
  class InfiniteScrollPagination extends HTMLElement {
    connectedCallback() {
      this.nextUrl = this.dataset.nextUrl;
      this.sectionId = this.dataset.sectionId;
      this.sentinel = this.querySelector('[data-infinite-sentinel]');
      this.spinner = this.querySelector('.infinite-scroll-pagination__spinner');
      if (!this.nextUrl || !this.sentinel) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) this.loadNext();
        },
        { rootMargin: '600px 0px 0px 0px' }
      );
      this.observer.observe(this.sentinel);
    }

    async loadNext() {
      if (this.loading || !this.nextUrl) return;
      this.loading = true;
      if (this.spinner) this.spinner.hidden = false;

      try {
        const separator = this.nextUrl.includes('?') ? '&' : '?';
        const response = await fetch(`${this.nextUrl}${separator}section_id=${this.sectionId}`);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const newGrid = doc.querySelector('[data-product-column]');
        const currentGrid = document.querySelector('[data-product-column]');
        if (newGrid && currentGrid) {
          Array.from(newGrid.children).forEach((child) => currentGrid.appendChild(child));
        }

        const newInfinite = doc.querySelector('infinite-scroll-pagination');
        this.nextUrl = newInfinite ? newInfinite.dataset.nextUrl : null;
        if (!this.nextUrl) {
          this.observer.disconnect();
          this.remove();
        }
      } catch (error) {
        // keep the sentinel in place so it retries on next intersection
      } finally {
        this.loading = false;
        if (this.spinner) this.spinner.hidden = true;
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }
  customElements.define('infinite-scroll-pagination', InfiniteScrollPagination);
}
